import React, { FC } from "react";
import { Card } from "@material-ui/core";
import useStyles from "./styles";

type Props = {
  classOverrides?: string;
};

const DPCard: FC<Props> = ({ children, classOverrides }) => {
  const classes = useStyles();

  return (
    <Card className={`${classes.card} ${classOverrides}`}>{children}</Card>
  );
};

export default DPCard;
